/** Opens the in-app customer activity capture form in a new tab. */
export function buildCustomerActivityCaptureFormUrl(): string {
  const hashPath = '#/customer-activity-capture';
  const origin = `${window.location.origin}${window.location.pathname}`;
  return `${origin}${hashPath}`;
}

export function openCustomerActivityCaptureForm(): boolean {
  window.open(
    buildCustomerActivityCaptureFormUrl(),
    '_blank',
    'noopener,noreferrer'
  );
  return true;
}
